import LanguageDialog from "./LanguageDialog";

class LanguageSwitcher {
  static initEvents() {
    (document.querySelectorAll<HTMLElement>(".language-switcher .language-current")).forEach((el) => {
      el.addEventListener("click", LanguageSwitcher.toggleMenu);
    });
    (document.querySelectorAll<HTMLElement>(".language-switcher a")).forEach((el) => {
      el.addEventListener("click", () => {
        // If the user clicks on a language link, we can assume they want to change language
        LanguageDialog.setDismissedCookie();
      });
    });
  }

  static toggleMenu(event: Event) {
    event.preventDefault();

    const current = event.currentTarget as HTMLElement;
    const switcher = current?.closest(".language-switcher") ?? null;

    if (switcher === null) {
      return;
    }

    switcher.classList.toggle("open");
  }
}

LanguageSwitcher.initEvents();
